import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import constants from "../../services/constants";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "lightgallery.js/dist/css/lightgallery.css";

const GalleryComponent = (props) => {
  const galleryImg = props.gallery;

  console.log(galleryImg); // Debugging step

  const getImageUrl = (index) => {
    if (galleryImg && galleryImg[index]?.image) {
      return `${constants.IMAGE_BASE_URL_WITHOUT_UPLOAD}/${galleryImg[index].image}`;
    }
    return ''; // Return empty string if no image exists
  };

  return (
    <div className={Style.eventSec + ' ' + Style.componentsSpace + ' ' + Style.noSpace}>
      <Container>
        <Row>
          <Col lg={12}>
            <div className={Style.center}>
              <h2 className={Style.abouttitle}>GALLERY</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={'lighBoxspace ' + Style.glleryBox}>
              <Row>
                <LightgalleryProvider lightgallerySettings={{ download: false }}>
                  {galleryImg && galleryImg.length > 0 && galleryImg.map((img, index) => (
                    <Col md={4} key={index}>
                      <LightgalleryItem group="group1" src={getImageUrl(index)}>
                        <div className={Style.imgBox}><img src={getImageUrl(index)} /></div>
                      </LightgalleryItem>
                    </Col>
                  ))}
                </LightgalleryProvider>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GalleryComponent;
